export interface Activity {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  time: string;
  location: string;
  participants: number;
  maxParticipants: number;
  image: string;
  description: string;
  host: string;
  hostAvatar: string;
}

export const activities: Activity[] = [
  {
    id: 'act-1',
    title: '周末香山徒步穿越',
    category: '户外运动',
    categorySlug: 'outdoor',
    date: '2026-08-10',
    time: '08:00 - 15:00',
    location: '北京香山公园',
    participants: 18,
    maxParticipants: 25,
    image: 'https://readdy.ai/api/search-image?query=Group%20hiking%20on%20mountain%20trail%20with%20autumn%20colors%2C%20warm%20sunlight%2C%20beautiful%20natural%20landscape%2C%20Chinese%20young%20people%20outdoor%20activity%2C%20clean%20editorial%20style&width=600&height=400&seq=activity-outdoor-1&orientation=landscape',
    description: '从香山公园出发，穿越至植物园，全程约8公里，难度适中，适合所有户外爱好者。沿途可以欣赏秋季红叶美景。',
    host: '山野行者',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20outdoor%20style%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-1&orientation=squarish',
  },
  {
    id: 'act-2',
    title: '尤克里里弹唱交流会',
    category: '音乐艺术',
    categorySlug: 'music',
    date: '2026-08-12',
    time: '14:00 - 17:00',
    location: '朝阳区音乐咖啡馆',
    participants: 12,
    maxParticipants: 20,
    image: 'https://readdy.ai/api/search-image?query=Ukulele%20jam%20session%20in%20cozy%20cafe%2C%20young%20people%20playing%20music%20together%2C%20warm%20indoor%20lighting%2C%20musical%20instruments%2C%20clean%20editorial%20style&width=600&height=400&seq=activity-music-1&orientation=landscape',
    description: '带上你的尤克里里，和社区的小伙伴们一起弹唱交流。无论你是初学者还是进阶玩家，都能在这里找到音乐的快乐。',
    host: '音符旅人',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20artistic%20look%2C%20warm%20smile%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-2&orientation=squarish',
  },
  {
    id: 'act-3',
    title: '手工提拉米苏烘焙课',
    category: '美食烹饪',
    categorySlug: 'food',
    date: '2026-08-13',
    time: '10:00 - 12:30',
    location: '海淀区共享厨房',
    participants: 8,
    maxParticipants: 12,
    image: 'https://readdy.ai/api/search-image?query=Group%20baking%20class%20in%20bright%20modern%20kitchen%2C%20people%20making%20desserts%20together%2C%20warm%20atmosphere%2C%20clean%20editorial%20food%20photography%20style&width=600&height=400&seq=activity-food-1&orientation=landscape',
    description: '专业烘焙师手把手教你制作经典提拉米苏，零基础也能学会。所有材料已备好，你只需要带着热情来参加！',
    host: '甜点达人',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20cheerful%2C%20apron%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-3&orientation=squarish',
  },
  {
    id: 'act-4',
    title: '八月读书分享会',
    category: '读书学习',
    categorySlug: 'reading',
    date: '2026-08-15',
    time: '15:00 - 17:00',
    location: '东城区三联书店',
    participants: 15,
    maxParticipants: 30,
    image: 'https://readdy.ai/api/search-image?query=Book%20club%20gathering%20in%20cozy%20bookstore%2C%20people%20discussing%20books%2C%20warm%20lighting%2C%20bookshelves%20background%2C%20clean%20editorial%20style&width=600&height=400&seq=activity-reading-1&orientation=landscape',
    description: '围绕《百年孤独》展开深度讨论，分享各自的阅读感悟。同时也欢迎推荐你最近在读的好书。',
    host: '书虫小姐',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20wearing%20glasses%2C%20intellectual%20look%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-4&orientation=squarish',
  },
  {
    id: 'act-5',
    title: '周五桌游之夜',
    category: '游戏电竞',
    categorySlug: 'gaming',
    date: '2026-08-09',
    time: '19:00 - 22:00',
    location: '望京桌游俱乐部',
    participants: 20,
    maxParticipants: 30,
    image: 'https://readdy.ai/api/search-image?query=Friends%20playing%20board%20games%20at%20table%2C%20colorful%20game%20pieces%2C%20warm%20evening%20lighting%2C%20fun%20social%20atmosphere%2C%20clean%20editorial%20style&width=600&height=400&seq=activity-gaming-1&orientation=landscape',
    description: '每周五的固定桌游聚会！本周主打阿瓦隆和璀璨宝石，也欢迎带自己喜欢的桌游来分享。',
    host: '桌游队长',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20enthusiastic%2C%20casual%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-5&orientation=squarish',
  },
  {
    id: 'act-6',
    title: '古北水镇周末摄影之旅',
    category: '摄影影像',
    categorySlug: 'photography',
    date: '2026-08-17',
    time: '全天',
    location: '密云古北水镇',
    participants: 10,
    maxParticipants: 15,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20water%20town%20with%20traditional%20architecture%2C%20reflections%20in%20canal%2C%20warm%20sunset%20light%2C%20photography%20theme%2C%20clean%20editorial%20travel%20style&width=600&height=400&seq=activity-photography-1&orientation=landscape',
    description: '两天一夜的摄影之旅，记录古北水镇最美的晨昏与夜景。专业摄影师随行指导，手机和相机用户均可参加。',
    host: '光影捕手',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20holding%20camera%2C%20creative%20look%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-6&orientation=squarish',
  },
  {
    id: 'act-7',
    title: '坝上草原露营观星',
    category: '户外运动',
    categorySlug: 'outdoor',
    date: '2026-08-24',
    time: '两天一夜',
    location: '丰宁坝上草原',
    participants: 22,
    maxParticipants: 40,
    image: 'https://readdy.ai/api/search-image?query=Camping%20in%20grassland%20with%20star%20sky%2C%20tents%20and%20campfire%2C%20milky%20way%20visible%2C%20warm%20evening%20atmosphere%2C%20clean%20editorial%20outdoor%20photography&width=600&height=400&seq=activity-outdoor-2&orientation=landscape',
    description: '坝上草原两日露营，白天骑马射箭，晚上篝火晚会和星空观测。提供帐篷租赁，新手友好！',
    host: '山野行者',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20outdoor%20style%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-1&orientation=squarish',
  },
  {
    id: 'act-8',
    title: '城市晨跑打卡挑战',
    category: '健身运动',
    categorySlug: 'fitness',
    date: '2026-08-11',
    time: '06:30 - 07:30',
    location: '奥林匹克森林公园',
    participants: 25,
    maxParticipants: 50,
    image: 'https://readdy.ai/api/search-image?query=Group%20morning%20run%20in%20urban%20park%20with%20sunrise%20light%2C%20Chinese%20young%20people%20jogging%2C%20green%20trees%2C%20fresh%20morning%20atmosphere%2C%20clean%20editorial%20fitness%20style&width=600&height=400&seq=activity-fitness-1&orientation=landscape',
    description: '清晨的奥森，和一群热爱跑步的朋友一起迎接第一缕阳光。5公里轻松跑，配速自由，重在参与和坚持。',
    host: '运动达人K',
    hostAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20athletic%2C%20friendly%20smile%2C%20warm%20lighting%2C%20minimal%20background%2C%20headshot&width=100&height=100&seq=host-7&orientation=squarish',
  },
];

export const getActivitiesByCategory = (categorySlug: string) => {
  return activities.filter((a) => a.categorySlug === categorySlug);
};

export const getUpcomingActivities = (limit: number = 6) => {
  const now = new Date();
  return activities
    .filter((a) => new Date(a.date) >= now)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .slice(0, limit);
};